<template>
  <div>
    <dx-chart ref="chart" :inverted="false" @point-click="onPointClick">
      <dx-tooltip :enabled="true" :customize-tooltip="customizeTooltip"/>
      <dx-adaptive-layout :width="adaptivelayoutwidth"/>
      <dx-size/>
      <dx-common-series-settings type="bar"/>
    </dx-chart>
  </div>
</template>

<script>
import {
  DxChart,
  DxAdaptiveLayout,
  DxCommonSeriesSettings,
  DxSize,
  DxTooltip
} from "devextreme-vue/chart";

export default {
  components: {
    DxChart,
    DxAdaptiveLayout,
    DxCommonSeriesSettings,
    DxSize,
    DxTooltip
  },

  props: {
    adaptivelayoutwidth: {
      type: Number,
      required: false,
      default: 450
    }
  },

  methods: {
    getInstance() {
      return this.$refs.chart.instance;
    },
    customizeTooltip: function(args) {
      // Niet zo mooi ik weet het but good enough for now
      if (args.total >= 1 && args.value >= 1)
      {
        return { html: `${args.seriesName} (${args.valueText})` }
      }
      else {
        return { html: `${args.seriesName} (${args.percentText})` }
      }
    }
  }
};
</script>
